import { ConnectionPositionPair } from '@angular/cdk/overlay';
import { ElementRef } from '@angular/core';
import { WIZ_UNITS } from '@wizeoo/akm-core-lib';

/**
 * Utility class for collections
 */
export class WizComponentUtils {

  /**
   * <p>Get Object Coordinates</p>
   *
   * @param pSource component
   * @return DOMRect
   */
  public static getComponentCoordinates(pSource: any): DOMRect {
    let domRect: DOMRect = null;
    const dest: HTMLElement = pSource instanceof HTMLElement ? pSource :
                pSource instanceof ElementRef ? pSource.nativeElement :
                'elementRef' in pSource ? pSource.elementRef : undefined;
    if (!!dest) {
      domRect = dest.getBoundingClientRect() as DOMRect;
    }
    return domRect;
  }

  /**
   * <p>convert number to 'n px' or 'n %' value</p>
   *
   * @param pMesure number
   * @param pUnit WIZ_UNITS.value
   * @return string
   */
  public static formatCoordinate(pMesure: number, pUnit: string= WIZ_UNITS.PIXEL): string {

    let res: string = pMesure.toString();
    res += pUnit;

    return res;
  }

 /**
  * Positions préférentielles de la pop
  */
 public static getPreferredPositions(): ConnectionPositionPair[] {
  return [
    {
      originX: 'start',
      originY: 'bottom',
      overlayX: 'start',
      overlayY: 'top'
    },
    {
      originX: 'start',
      originY: 'top',
      overlayX: 'start',
      overlayY: 'bottom',
    },
    {
      originX: 'start',
      originY: 'top',
      overlayX: 'start',
      overlayY: 'top',
    },
    {
      originX: 'start',
      originY: 'bottom',
      overlayX: 'start',
      overlayY: 'bottom'
    }
  ];
 }

}
